<template>
  <div ref="whole_page" v-show="isCardActiveLocal">
    <course-viewer-quiz :isCardActive="isCardActive"
                        :quiz="quiz"
                        :cardHeight="backgroundCardHeight"
                        :cardWidth="backgroundCardWidth"
                        :uuid="uuid"
                        @finishQuiz="quizFinished"
                        @nextTask="closePopup"
                        :key="index"
                        :isStudentProp="true"
                        :logData="logData"
                        :taskTypeId="taskTypeId"
                        :isQuizPopup="true"
                        :timeCapture="timeCapture"
                        />
  </div>
</template>
<script>
  import CourseViewerQuiz from '@/components/courseviewer/CourseViewerQuiz.vue';
  import { uuid } from 'vue-uuid';

  export default {
    components: {
      CourseViewerQuiz
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      quizProp: {
        type: Object,
        required: true
      },
      popupXBtnClicked: {
        type: Boolean,
        required: false
      },
      taskTypeId: {
        type: Number,
        required: false
      },
      timeCapture: {
        type: Object,
        required: false
      },
    },
    data() {
      return {
        backgroundCardHeight: "",
        backgroundCardWidth: "",
        uuid: "",
        quiz: {},
        logData: {},
        index: 0,
        isQuizFinished: false
      }
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          self.isQuizFinished = false;
          self.showQuiz();
          self.resizeCard();
          self.index++;
        }
      },
      popupXBtnClicked: function(val) {
        var self = this;
        if(val && !self.isQuizFinished) {
          var payload = {
            logIdentifier: self.uuid,
            toTaskId: null,
            fromTaskId: null,
            taskId: self.quizProp.id
          };

          self.$emit("postEndLog", payload);
        }
        else if(val && self.isQuizFinished) {
          self.$emit("refreshTasks");
        }
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            
          }
        }
      }
    },
    methods: {
      showQuiz() {
        var self = this;
        self.isQuizFinished = false;
        if (self.quizProp) {
          //Check if on mobile
          if (self.isMobile() && self.quizProp.isDecisive) {
            self.$vs.dialog({
              type: "confirm",
              color: "warning",
              title: "Mobile Device Detected",
              text: "Unfortunately this quiz cannot be completed on a mobile device (smartphone or tablet).\n\nPlease log in again from a computer (laptop or desktop-computer).",
              accept: self.closePopup,
              acceptText: "Close",
              cancel: self.closePopup
            });
            return;
          }

          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.quizProp.id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = null;
          self.logData.toTaskId = null;
          self.logData.quizId = self.quizProp.quizId;

          self.quiz = self.quizProp;
        }
      },
      resizeCard() {
        var ratio = 0.434;

        if ((window.innerWidth * 0.9) < 1555.55)
          this.backgroundCardWidth = window.innerWidth * 0.9;
        else
          this.backgroundCardWidth = 1555.55 * 0.9;

        this.backgroundCardHeight = this.backgroundCardWidth * ratio;
      },
      quizFinished(quizResults) {
        var self = this;
        self.logData.fromTaskId = null;
        self.logData.toTaskId = null;

        var payload = {
          logIdentifier: self.logData.logIdentifier,
          toTaskId: self.logData.fromTaskId,
          fromTaskId: self.logData.toTaskId,
          taskId: self.quizProp.id
        };

        self.isQuizFinished = true;
        
        if (quizResults) {
          self.$ajaxPost(self, "QuizTask/EndLogEntry", payload);
        } else if (self.taskTypeId == 14) {
          self.$ajaxPost(self, "VideoQuizTask/EndLogEntry", payload);
        }
      },
      closePopup() {
        this.$emit("closePopup")
      }
    },
    mounted() {
      var self = this;
      self.$nextTick(() => {
        window.addEventListener("resize", () => {
          self.resizeCard();
        });
      });
    },
    created() {
      this.resizeCard();
    }
  }
</script>
<style lang="scss">
  #quizViewPopup div.vs-popup {
    width: 100%;
    height: 100%;

    .vs-popup--content {
      max-height: calc(100vh - 100px);
    }
  }

</style>